import { extend } from 'flarum/extend';
import EditUserModal from "flarum/components/EditUserModal";

export default function () {
  extend(EditUserModal.prototype, 'fields', function(items) {
    // We remove the password options as login goes through Unilogin.
    if (items.has('password')){
      items.remove('password');
    }
  });
}
